import PayUInfoWithTooltip from 'views/BrandConfiguration/PayUInfoWithTooltip';
import { TableCell, TableRow } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import Info from '@material-ui/icons/Info';
import InfoWithTooltip from 'components/InfoWithTooltip/InfoWithTooltip';
import EXTERNAL_URLS from 'constants/externalUrls';
import makeStyles from '@material-ui/styles/makeStyles';

import PaymentRow from './PaymentRow';

const useStyles = makeStyles({
  paymentModuleTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
});

const PaymentMethodManagementSection = ({
  modules,
  paymentTypes,
  setModules,
  validateChangeStatusPaymentType,
  handleChangePaymentMethod,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const paymentRowSharedProps = {
    modules,
    paymentTypes,
    setModules,
    validateChangeStatusPaymentType,
    handleChangePaymentMethod,
  };

  return (
    <>
      <TableRow>
        <TableCell rowSpan={7}>
          <div className={classes.paymentModuleTitle}>
            {t('paymentType.moduleName.title.payU')}
            <PayUInfoWithTooltip />
          </div>
        </TableCell>
        <PaymentRow
          value={{
            title: 'PayU',
            paymentTypeStandard: 'PAYU_CARD',
            paymentTypeSubscription: 'PAYU_CARD',
            option: 'cardPaymentsEnabled',
            method: t('paymentType.payUCardNew'),
            tooltip: (
              <Tooltip
                title={t('paymentType.payUCard.tooltip')}
                placement="right"
              >
                <Info fontSize="small" />
              </Tooltip>
            ),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <PaymentRow
          value={{
            title: 'PayU',
            paymentTypeStandard: 'PAYU_PAYPO',
            option: 'payPo',
            method: t('paymentType.payUPayPoNew'),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <PaymentRow
          value={{
            title: 'PayU',
            paymentTypeStandard: 'PAYU_GOOGLE_PAY',
            option: 'googlePayEnabled',
            method: t('paymentType.payUGooglePayNew'),
            tooltip: (
              <InfoWithTooltip
                link={EXTERNAL_URLS.configurationGooglePay}
                linkText={t('paymentType.configurationGooglePay.tooltip')}
              />
            ),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <PaymentRow
          value={{
            title: 'PayU',
            paymentTypeStandard: 'PAYU_APPLE_PAY',
            option: 'applePayEnabled',
            method: t('paymentType.payUApplePayNew'),
            tooltip: (
              <InfoWithTooltip
                link={EXTERNAL_URLS.configurationApplePay}
                linkText={t('paymentType.configurationApplePay.tooltip')}
              />
            ),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <PaymentRow
          value={{
            title: 'PayU',
            paymentTypeStandard: 'PAYU',
            method: t('paymentType.payU'),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <PaymentRow
          value={{
            title: 'PayU',
            paymentTypeStandard: 'PAYU_BLIK',
            option: 'blik',
            method: t('paymentType.payUBlikNew'),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <PaymentRow
          value={{
            title: 'PayU',
            paymentTypeStandard: 'PAYU_BLIK_PAY_LATER',
            method: t('paymentType.payUBlikPayLater'),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <PaymentRow
          value={{
            title: 'PayU',
            paymentTypeStandard: 'PAYU_SANDBOX',
            option: 'sandbox',
            method: t('paymentType.payUSandbox'),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <TableCell rowSpan={2}>
          <div className={classes.paymentModuleTitle}>
            {t('paymentType.moduleName.title.stripe')}
            <InfoWithTooltip
              link={EXTERNAL_URLS.configurationStripe}
              linkText={t('paymentType.configurationStripe.tooltip')}
            />
          </div>
        </TableCell>
        <PaymentRow
          value={{
            title: 'Stripe',
            paymentTypeStandard: 'STRIPE_CARD',
            paymentTypeSubscription: 'STRIPE_CARD',
            option: 'cardPayments',
            method: t('paymentType.stripeCardNew'),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <PaymentRow
          value={{
            title: 'Stripe',
            paymentTypeStandard: 'STRIPE_LINK',
            method: t('paymentType.stripeLink'),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <TableCell>{t('paymentType.moduleName.title.payPo')}</TableCell>
        <PaymentRow
          value={{
            title: 'PayPo',
            paymentTypeStandard: 'PAYPO',
            method: t('paymentType.payPo'),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <TableCell rowSpan={2}>
          <div className={classes.paymentModuleTitle}>
            {t('paymentType.moduleName.title.payNow')}
            <InfoWithTooltip
              link={EXTERNAL_URLS.configurationPayNow}
              linkText={t('paymentType.configurationPayNow.tooltip')}
            />
          </div>
        </TableCell>
        <PaymentRow
          value={{
            title: 'PayNow',
            paymentTypeStandard: 'PAYNOW',
            method: t('paymentType.payNow'),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <PaymentRow
          value={{
            title: 'PayNow',
            paymentTypeStandard: 'PAYNOW_SANDBOX',
            option: 'sandbox',
            method: t('paymentType.payNowSandbox'),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <TableCell rowSpan={3}>
          <div className={classes.paymentModuleTitle}>
            {t('paymentType.montonio')}
            <InfoWithTooltip
              link={EXTERNAL_URLS.configurationMontonio}
              linkText={t('paymentType.configurationMontonio.tooltip')}
            />
          </div>
        </TableCell>
        <PaymentRow
          value={{
            title: 'Montonio',
            paymentTypeStandard: 'MONTONIO_LINK_BANK',
            method: t('paymentType.montonioBankWire'),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <PaymentRow
          value={{
            title: 'Montonio',
            paymentTypeStandard: 'MONTONIO_LINK_CARD',
            method: t('paymentType.montonioPaymentType'),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
      <TableRow>
        <PaymentRow
          value={{
            title: 'Montonio',
            paymentTypeStandard: 'MONTONIO_SANDBOX',
            option: 'sandbox',
            method: t('paymentType.montonioSandbox'),
          }}
          {...paymentRowSharedProps}
        />
      </TableRow>
    </>
  );
};

export default PaymentMethodManagementSection;
